import { render, staticRenderFns } from "./StaffAdminPageTableControl.vue?vue&type=template&id=3d0bebd3&scoped=true&"
import script from "./StaffAdminPageTableControl.vue?vue&type=script&lang=js&"
export * from "./StaffAdminPageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0bebd3",
  null
  
)

export default component.exports